export default function Row({ children, className = "" }) {
  const classes = `flex items-center gap-2 ${className}`;
  return <div className={classes}>{children}</div>;
}
